import script from "./Legend.vue?vue&type=script&setup=true&lang=js"
export * from "./Legend.vue?vue&type=script&setup=true&lang=js"

import "./Legend.vue?vue&type=style&index=0&id=0a8104ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8104ea"]])

export default __exports__